import { hideElement, showElement } from '../../../shared/utilities/show-hide';
import pubsub from '../../../shared/utilities/pubsub';
import BaseBehavior from '../../../framework/base/base';
import { getCookie, setCookie } from '../../../shared/utilities/cookies';
import restrictBodyScroll from '../../../shared/utilities/restrict-body-scroll';

const institutionCookieName = 'iit_institutionConsent';
const cookieConsentCookieName = 'CookieConsent';

export default class InstitutionDisclaimer extends BaseBehavior {
	constructor(element) {
		super(element);
		// sections
		this.initDomCache();

		let timeoutDelay = 100;
		const self = this;
		let timer = setTimeout(function checkDOMReadyState() {
			if (document.readyState === 'complete') {
				self.addEventListeners();
				self.init();
				clearTimeout(timer);
			} else {
				timeoutDelay += 100;
				timer = setTimeout(checkDOMReadyState, timeoutDelay);
			}
		}, timeoutDelay);

		this.cookiePopup = document.querySelector('#cookie-popup');
	}

	addEventListeners() {
		// subscribe to trigger
		pubsub.subscribe('institution-disclaimer/open', isCookiePopClosing => {
			this.showInstitutionPopup(isCookiePopClosing);
		});

		this.addEventListener(this.dom.acceptBtn, 'click.accept', this.onAccept.bind(this));
	}

	init() {
		this.showInstitutionPopup();
	}

	/**
	 * set 'isCookiePopClosing' param to true on cookie popup close
	 * as we cannot rely on 'cookieConset' cookie value just after
	 * cookie pop up is being closed.
	 */
	showInstitutionPopup(isCookiePopClosing) {
		const institutionConsent = getCookie(institutionCookieName);
		const isCookiePopupHidden = this.getIsCookiePopHidden(isCookiePopClosing);
		if (isCookiePopupHidden && !institutionConsent) {
			restrictBodyScroll(true);
			showElement(this.element);
		}
	}

	getIsCookiePopHidden(isCookiePopClosing) {
		const isCookiePopupRendered = Boolean(this.cookiePopup);
		if (!isCookiePopupRendered) {
			return !isCookiePopupRendered;
		}

		const cookieConsent = getCookie(cookieConsentCookieName);
		return cookieConsent || isCookiePopClosing;
	}

	hideInstitutionPopup() {
		restrictBodyScroll(false);
		hideElement(this.element);
	}

	onAccept(e) {
		e.preventDefault();
		setCookie(institutionCookieName, 'true', new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
		this.hideInstitutionPopup();
	}
}
